import { useState } from 'preact/hooks';

import { Session } from './screens/Session';
import { Start } from './screens/Start';
import { Trust } from './screens/Trust';

/**
 * Three routes: `/s/<link token>` (start page), `/trust/<survey slug>` (trust page) and `/` (the
 * session in this browser's cookie).
 */
export function App() {
  const [path, setPath] = useState(location.pathname);
  // The resume token is shown once, right after starting; it is kept in memory only.
  const [resumeToken, setResumeToken] = useState<string | null>(null);
  const linkToken = /^\/s\/([A-Za-z0-9_-]+)$/.exec(path)?.[1];
  const trustSlug = /^\/trust\/([a-z0-9-]+)$/.exec(path)?.[1];

  if (trustSlug) return <Trust surveySlug={trustSlug} />;
  if (linkToken) {
    return (
      <Start
        token={linkToken}
        onStarted={(token) => {
          setResumeToken(token);
          // The link token must not linger in the address bar or history.
          history.replaceState(null, '', '/');
          setPath('/');
        }}
      />
    );
  }
  return <Session resumeToken={resumeToken} resumeInvalid={new URLSearchParams(location.search).get('resume') === 'invalid'} />;
}
